import DefaultLayout from 'components/layout/DefaultLayout'
import colors from '../../../styles/colors.module.scss';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { AvailableIcon, CallCenterListIcon1, DepartmentIcon, ExtensionIcon, IncomingCallsIcon, LoggedOutIcon, OnCallIcon, OutgoingCallsIcon, ParkedCallsIcon, TireIcon, TotalCallsIcon, TotalUsersIcon, UserIcon, WaitingIcon } from 'assets';
import './callCenter.scss'
import MiniCard from '../LiveCalls/MiniCard';
import SwitchHeader from './SwitchHeader';
import { Accordion, AvatarToolTip, Loader, Typography } from 'components/common';
import { useSortingAccordion } from 'hooks/useSortingAccordion';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { Agent } from 'redux/slices/agents.slice';
import { Queue } from 'redux/slices/queues.slice';
import FilterHeader from './FilterHeader';
import CallCenterCallItemCard from './CallCenterCallItemCard';
import InfoDrawer from '../LiveCalls/InfoDrawer';
import { ActiveAgentsResponse, fetchActiveAgents } from '../../../redux/thunks/CallCenterThunks/fetchActiveAgents';
import { CallCenterAgent, fetchCallCenterAgents } from '../../../redux/thunks/CallCenterThunks/callCenterAgents';
import useCallCenterSocket from 'hooks/useCallCenterSocket';
import { QueuedCall, removeCallCenterCallByAgentId, updateCallCenterCalls, removeAllCallCenterHoldCalls } from '../../../redux/slices/CallCenterSlices/callCenterCalls.slice';
import { useCallTimers } from 'hooks/useCallTimers';
import { ActiveCall, removeActiveCallsCallCenter, updateActiveCallsCallCenter, removeAllActiveCallCenterData } from '../../../redux/slices/CallCenterSlices/activeCallCenter.slice';
import { createAgentsOffering } from '../../../redux/slices/CallCenterSlices/agentsOffering.slice';
import { removeAllQueueMembers } from '../../../redux/slices/CallCenterSlices/activeAgents.slice';
import { generateNameSpaceColor } from '../../../utils/generateNameSpaceColor'

type QueueWithAgentCount = Queue & {
  agentCount: number;
};

interface ExtendedQueuedCall extends QueuedCall {
  departColor: string;
  queueName: string; // override string to ensure mapped name
}

interface ExtendedActiveCall extends ActiveCall {
  departColor: string;
  queueName: string; // override with mapped department name
}


const CallCenterDefault = () => {
  useCallCenterSocket();
  const [activeTab, setActiveTab] = useState<'agents' | 'departments'>('departments');
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [queueItems, setQueueItems] = useState<ExtendedQueuedCall[]>([]);
  const [activeCalls, setActiveCalls] = useState<ExtendedActiveCall[]>([]);
  const hasRunOnce = useRef(false);
  const dispatch = useAppDispatch();
  const { calculateTimer } = useCallTimers();
  const account_id = sessionStorage.getItem("account_id");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedCall, setSelectedCall] = useState<QueuedCall | ActiveCall | null>(null);
  //call center agents
  const { items: callCenterAgents, status } = useAppSelector(item => item.callCenterAgents)
  // all queued calls
  const queuedCalls = useAppSelector((state) => state.callCenterCalls.items);
  console.log('queued calls', queuedCalls)
  // all queues 
  const departments = useAppSelector(item => item.queues.items)
  // all active calls
  const activeCallCenterCalls = useAppSelector(state => state.activeCallCenter.items)
  console.log('call center calls active', activeCallCenterCalls)
  // /active api queues and agents
  const activeCallsInitial = useAppSelector(item => item.activeAgents.items)
  // agents offering data from socket
  const agentOffering = useAppSelector((state) => state.agentsOffering.items);
const normalizedActiveCallsInitial: Required<ActiveAgentsResponse> = {
  agents: Array.isArray(activeCallsInitial?.agents) ? activeCallsInitial!.agents : [],
  queues: Array.isArray(activeCallsInitial?.queues) ? activeCallsInitial!.queues : [],
};

  const miniCardsData = useMemo(() => [
    {
      value: "3m 25s",
      heading: "Average Waiting Time",
      iconClassName: IncomingCallsIcon,
      containerBg: colors.lightGreen,
      imageContainerBg: colors.darkGreen,
    },
    {
      value: "10m 35s",
      heading: "Max Waiting Time",
      iconClassName: OutgoingCallsIcon,
      containerBg: colors.lightPurple,
      imageContainerBg: colors.darkPurple,
    },
    {
      value: "3s",
      heading: "Least Waiting Time",
      iconClassName: ParkedCallsIcon,
      containerBg: colors.lightMaroon,
      imageContainerBg: colors.darkMaroon,
    },
    {
      value: "1245",
      heading: "Total Calls",
      iconClassName: TotalCallsIcon,
      containerBg: colors.lightOrange,
      imageContainerBg: colors.darkOrange,
    },
    {
      value: "35",
      heading: "Missed Calls",
      iconClassName: TotalUsersIcon,
      containerBg: colors.lightCyan,
      imageContainerBg: colors.darkCyan,
    },
    {
      value: "3m 25s",
      heading: "Average Waiting Time",
      iconClassName: IncomingCallsIcon,
      containerBg: colors.lightGreen,
      imageContainerBg: colors.darkGreen,
    },
    {
      value: "10m 35s",
      heading: "Max Waiting Time",
      iconClassName: OutgoingCallsIcon,
      containerBg: colors.lightPurple,
      imageContainerBg: colors.darkPurple,
    },
  ], []);

  const {
    sortOrder,
    selectedTitle,
    menuItems,
    setSelectedTitle,
  } = useSortingAccordion();

  type StatusKey = 'Waiting' | 'In a queue call' | 'Receiving' | 'Logged Out';

  const statusIconMap: Record<StatusKey, string> = {
    Waiting: WaitingIcon,
    'In a queue call': OnCallIcon,
    Receiving: AvailableIcon,
    'Logged Out': LoggedOutIcon,
  };

  const sortByName = useCallback(
    <T extends { name: string; extension?: string }>(list: T[], order: 'asc' | 'desc') =>
      [...list].sort((a, b) => {
        // Prefer extension for agents
        const aValue = a.extension ?? a.name;
        const bValue = b.extension ?? b.name;

        const aIsNumeric = !isNaN(Number(aValue));
        const bIsNumeric = !isNaN(Number(bValue));

        if (aIsNumeric && bIsNumeric) {
          const numA = Number(aValue);
          const numB = Number(bValue);
          return order === 'asc' ? numA - numB : numB - numA;
        }


        const strA = aValue.toLowerCase();
        const strB = bValue.toLowerCase();
        return order === 'asc' ? strA.localeCompare(strB) : strB.localeCompare(strA);
      }),
    []
  );

  const queuesWithAgentCount = useMemo(() => {
  const queues = Array.isArray(normalizedActiveCallsInitial?.queues) ? normalizedActiveCallsInitial.queues : [];

  return departments.map(queue => {
    const activeQueue = queues.find(item => item.name === queue.extension);
    return {
      ...queue,
      agentCount: Array.isArray(activeQueue?.tiers) ? activeQueue?.tiers?.length ?? 0 : 0

    };
  });
}, [departments, normalizedActiveCallsInitial?.queues]);

  const agentQueuesMap = useMemo(() => {
    const map: Record<string, { queueName: string }[]> = {};

    const queues = Array.isArray(normalizedActiveCallsInitial?.queues) ? normalizedActiveCallsInitial.queues : [];

queues.forEach(queue => {
      const matchingDepartment = departments.find(dep => dep.extension === queue.name);
      const queueName = matchingDepartment?.name || queue.name;
      queue.tiers.forEach(tier => {
        const agentId = tier.agent;
        if (!map[agentId]) {
          map[agentId] = []
        }
        map[agentId].push({ queueName });
      }
      )
    })
    return map
  }, [normalizedActiveCallsInitial?.queues, departments])


  const agentTiersMap = useMemo(() => {
    const map: Record<string, number[]> = {}
    if (!Array.isArray(normalizedActiveCallsInitial?.queues)) return map;
const queues = Array.isArray(normalizedActiveCallsInitial?.queues) ? normalizedActiveCallsInitial.queues : [];

queues.forEach(queue => {
      queue.tiers.forEach(tier => {
        const agentId = tier.agent;

        if (!map[agentId]) {
          map[agentId] = [];
        }

        map[agentId].push(Number(tier.level));
      })
    })

    return map
  }
    , [normalizedActiveCallsInitial?.queues])

  const getQueueNameFromExtension = (queueField?: string): string => {
    if (!queueField) return 'Unknown Queue';

    // Cleaned version of the queue value (remove "@..." if present)
    const extension = queueField.includes('@')
      ? queueField.split('@')[0]
      : queueField.trim();

    const matchedQueue = departments.find(dep => dep.extension === extension);
    return matchedQueue?.name || `Queue ${extension}`;
  };



  const agentExtensionsMap = useMemo(() => {
    const map: Record<string, string[]> = {};

    agentOffering.forEach((entry) => {
      const agentId = entry?.agent?.split('@')[0]; // extract UUID before @
      const matchedAgent = callCenterAgents.find((a) => a.name === agentId);
      const extension = matchedAgent?.extension;

      if (!extension) return; // skip if not found

      if (!map[entry.sessionUUID]) {
        map[entry.sessionUUID] = [];
      }

      map[entry.sessionUUID].push(extension);
    });

    return map;
  }, [agentOffering, callCenterAgents]);

  const sortedList = useMemo(() => {
    const listToSort =
      activeTab === 'agents'
        ? (callCenterAgents as { name: string }[])
        : (queuesWithAgentCount as { name: string }[]);

    return sortByName(listToSort, sortOrder);
  }, [activeTab, callCenterAgents, queuesWithAgentCount, sortOrder, sortByName]);

  /*const createCall = (index: number): CallCenterCall => {
    const userNames = ["John Wilson", "Emily Davis", "Michael Smith", "Sarah Johnson", "David Lee"];
    const queues = ["120 Test Queue", "Tech_Support", "Test_Queue"];

    return {
      phoneNumber: `(800) 000-${(1000 + index).toString().slice(-4)}`,
      userName: userNames[index % userNames.length],
      serialNo: `#${index + 1}`,
      agentsCount: 50 + (index % 100),
      departmentName: queues[index % queues.length],
      duration: `00:${String(5 + (index % 10)).padStart(2, '0')}:${String(index % 60).padStart(2, '0')}`,
      onEndCall: () => console.log(`End call clicked for item ${index}`),
    };
  };

  const generateCalls = (): CallCenterCall[] =>
    Array.from({ length: 12 }, (_, index) => createCall(index));

  const [activeCalls, setActiveCalls] = useState<CallCenterCall[]>(() => generateCalls());*/

  const handleCancel = () => {
    setModalOpen(false);
  };

  const handleCallClick = (call: QueuedCall | ActiveCall) => {
    setSelectedCall(call);
    setModalOpen(true);
  };

  useEffect(() => {
    if (!account_id) return;
    dispatch(fetchActiveAgents());
    dispatch(fetchCallCenterAgents())
  }, [dispatch, account_id]);

  useEffect(() => {
    const queues = Array.isArray(normalizedActiveCallsInitial?.queues) ? normalizedActiveCallsInitial.queues : [];

if (queues.length > 0) {
  queues.forEach((item) => {
    if (Array.isArray(item.members) && item.members.length > 0) {
      item.members.forEach((member) => {
        if (member.state == "Trying" && Array.isArray(item.tiers)) {
          item.tiers.forEach((tier) => {
            if (tier.state == "Offering") {
              dispatch(createAgentsOffering({
                uuid: member?.uuid,
                sessionUUID: member?.sessionUUID,
                queue: item?.name,
                callerIDName: member?.callerIDName,
                callerIDNumber: member?.callerIDNumber,
                event: "agent-offering",
                domain: "",
                agent: `${tier?.agent}`,
              }));
            }
          });
        }
      });
    }
  });
}

  }, [normalizedActiveCallsInitial]);

  useEffect(() => {
    if (!normalizedActiveCallsInitial?.queues?.length || hasRunOnce.current) return;

  hasRunOnce.current = true;

    const activeCalls: ActiveCall[] = [];
    const callsOnHold: QueuedCall[] = [];

    const queues = Array.isArray(normalizedActiveCallsInitial?.queues) ? normalizedActiveCallsInitial.queues : [];

queues.forEach((queue) => {
  if (!Array.isArray(queue.members)) return;

  queue.members.forEach((member) => {
    if (member.state === 'Trying') {
      callsOnHold.push({
        memberCIDName: member.callerIDName,
        memberCIDNumber: member.callerIDNumber,
        joinedEpoch: member.joinedEpoch,
        queueName: queue.name,
        sessionUUID: member.sessionUUID,
        queue: queue.name,
        agentName: '',
      });
    } else if (member.state === 'Answered') {
      activeCalls.push({
        memberCIDName: member.callerIDName,
        memberCIDNumber: member.callerIDNumber,
        joinedEpoch: member.joinedEpoch,
        calledTime: member.joinedEpoch,
        queueName: queue.name,
        agentName: '',
        memberSessionUUID: member.sessionUUID,
        name: member.agent,
      });
    }
  });
});


    if (activeCalls.length || callsOnHold.length) {
      dispatch(removeAllQueueMembers());
      dispatch(updateCallCenterCalls(callsOnHold));
      dispatch(updateActiveCallsCallCenter(activeCalls));
    }
  }, [normalizedActiveCallsInitial]);

  useEffect(() => {
    if (departments && queuedCalls) {
      const finalQueues: ExtendedQueuedCall[] = [];
      queuedCalls.forEach((element) => {
        if (element.queue) {
          departments.forEach((data) => {
            if (element.queue?.split("@")[0] == data.extension) {
              let color = generateNameSpaceColor(data.name);
              let obj = {
                ...element,
                queueName: data.name,
                departColor: color,
              };
              finalQueues.push(obj);
              // setfinalQueuesment((prev) => [...prev, obj]);
            }
          });
        } else if (element.queueName) {
          departments.forEach((data) => {
            if (element.queueName == data.extension) {
              let color = generateNameSpaceColor(data.name);

              let obj = {
                ...element,
                queueName: data.name,
                departColor: color,
              };
              finalQueues.push(obj);
              // setfinalQueuesment((prev) => [...prev, obj]);
            }
          });
        }
      });
      setQueueItems(finalQueues);
    }
  }, [queuedCalls, departments]);

  useEffect(() => {
    if (departments && activeCallCenterCalls) {
      const finalActiveCalls: ExtendedActiveCall[] = [];
      activeCallCenterCalls?.forEach((element) => {
        if (element.queue) {
          departments.forEach((data) => {
            if (element?.queue?.split("@")[0] == data.extension) {
              let color = generateNameSpaceColor(data.name);

              let obj = {
                ...element,
                queueName: data.name,
                departColor: color,
              };
              finalActiveCalls.push(obj);
              // setfinalQueuesment((prev) => [...prev, obj]);
            }
          });
        } else if (element.queueName) {
          departments.forEach((data) => {
            if (element.queueName == data.extension) {
              let color = generateNameSpaceColor(data.name);

              let obj = {
                ...element,
                queueName: data.name,
                departColor: color,
              };
              finalActiveCalls.push(obj);
              // setfinalQueuesment((prev) => [...prev, obj]);
            }
          });
        }
      });
      setActiveCalls(finalActiveCalls);
    }
  }, [activeCallCenterCalls, departments]);

  useEffect(() => {
    return () => {
      dispatch(removeAllActiveCallCenterData());
      dispatch(removeAllCallCenterHoldCalls());
      hasRunOnce.current = false;
    };
  }, []);

  return (
    <DefaultLayout>
      <div className="call-center-container">
        <div className='call-center-body-container'>
          <div className="call-center-mini-cards-container">{miniCardsData.map((card, idx) => <MiniCard key={idx} {...card} />)}</div>
          {/* Agents / Departments */}
          <div className="departments-agents-container">
            <div>
              <SwitchHeader activeTab={activeTab} setActiveTab={setActiveTab} />
            </div>
            <div className="sorting-accordion">
              <Accordion
                labelName="Filter By"
                isTitleStatic={false}
                theme="dark"
                menuItems={menuItems}
                selectedTitle={selectedTitle}
                onSelectedTitleChange={setSelectedTitle}
              />
            </div>
            <ul className="list-container">
              {status === 'loading' && callCenterAgents.length > 0 && departments.length > 0 ? (
                <div className="loader">
                  <Loader />
                </div>
              ) : (
                <>
                  {sortedList.length>0?(
                  sortedList.map((item) => (
                    <li key={activeTab === 'agents' ? (item as CallCenterAgent).name : (item as QueueWithAgentCount).id} className="list-item-container">
                      {activeTab === 'agents' ? (
                        (() => {
                          const agent = item as CallCenterAgent;
                          const matchedActiveAgent = Array.isArray(normalizedActiveCallsInitial?.agents)
  ? normalizedActiveCallsInitial.agents.find((a) => a.name === agent.name)
  : undefined;

                          const rawStatus = matchedActiveAgent?.status === 'Logged Out'
                            ? matchedActiveAgent.status
                            : matchedActiveAgent?.state;

                          const allowedStatuses: StatusKey[] = ['Waiting', 'In a queue call', 'Receiving', 'Logged Out'];

                          const status: StatusKey = allowedStatuses.includes(rawStatus as StatusKey)
                            ? (rawStatus as StatusKey)
                            : 'Logged Out';

                          const activeCall = activeCallCenterCalls?.find((call) => call.agentName === agent.name)

                          return (
                            <>
                              <div className="list-icon-container">
                                <div className="list-icon">
                                  <img src={CallCenterListIcon1} alt="call-center-list-icon" />
                                </div>
                              </div>
                              <div className="list-title-extension">
                                <Typography variant="subHeading-1">
                                  {agent?.extension || 'Unnamed agent'}
                                </Typography>
                                <Typography variant="small-text-4">
                                  {agent?.extension}
                                </Typography>
                              </div>
                              <div className="list-info-container">
                                <div className="list-info">
                                  <div className='tier'>
                                    <img src={TireIcon} alt="tier-icon" />
                                    <Typography variant='small-text-4'>
                                      {agentTiersMap[agent.name]?.length ? agentTiersMap[agent.name].map(tier => `Tier ${tier}`).join(', ') : 'No Tiers'}
                                    </Typography>
                                  </div>
                                  <div className='queues'>
                                    <img src={DepartmentIcon} alt="department-icon" />
                                    <div>
                                      {agent?.name && agentQueuesMap[agent.name]?.length > 0 ? (
                                        <AvatarToolTip
                                          items={agentQueuesMap[agent.name].map((q, index) => ({
                                            value: q.queueName,
                                          }))}
                                          maxCount={1}
                                        />
                                      ) : (
                                        <Typography variant='small-text-4'>No Queues</Typography>
                                      )}

                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="list-status">
                                <div>
                                  <img
                                    src={statusIconMap[status] || LoggedOutIcon}
                                    alt={`${status} icon`}
                                  />
                                  <div>
                                    <Typography variant="text-2">
                                      {status === 'In a queue call'
                                        ? 'On Call'
                                        : status === 'Logged Out'
                                          ? 'Logout'
                                          : status || 'Unknown'}

                                    </Typography>

                                  </div>
                                </div>
                                {status === 'In a queue call' && activeCall?.memberCIDNumber && (
                                  <div>

                                    <Typography variant="small-text-4">
                                      {activeCall.memberCIDNumber}
                                    </Typography>


                                  </div>
                                )}
                              </div>

                            </>
                          );
                        })()
                      ) : (
                        (() => {
                          const department = item as QueueWithAgentCount;
                          const answeredCount = activeCallCenterCalls?.filter((call) => call.queueName ? call.queueName === department.extension : call.queue?.split('@')[0] === department.extension).length ?? 0;
                          const waitingCount = queuedCalls?.filter((call) => call.queueName ? call.queueName === department.extension : call.queue?.split('@')[0] === department.extension).length ?? 0;

                          return (
                            <>
                              <div className="list-icon-container">
                                <div className="list-icon">
                                  <img src={CallCenterListIcon1} alt="call-center-list-icon" />
                                </div>
                              </div>
                              <div className="list-title">
                                <Typography variant="subHeading-1">{department.name}</Typography>
                              </div>
                              <div className="list-info-container">
                                <div className="list-info">
                                  <div className='tier'>
                                    <i className="bx bxs-phone"></i>
                                    <Typography variant='small-text-4'>{answeredCount} Answered Calls</Typography>
                                  </div>
                                  <div className='tier'>
                                    <i className="bx bxs-time"></i>
                                    <Typography variant='small-text-4'>{waitingCount} Waiting</Typography>
                                  </div>
                                </div>
                              </div>
                              <div className="list-quantity-container">
                                <div className="list-quantity">
                                  <i className="bx bx-group"></i>
                                  <Typography variant="subHeading-2">
                                    {
                                      queuesWithAgentCount.find((q) => q.id === department.id)?.agentCount ?? 0
                                    }
                                  </Typography>
                                </div>
                              </div>
                            </>
                          );
                        })()
                      )}
                    </li>
                  ))):(<div className="empty-list-message">
    <Typography variant="subHeading-2" style={{ textAlign: 'center', marginTop: '1rem' }}>
      {activeTab === 'agents' ? 'No agents found' : 'No queues found'}
    </Typography>
  </div>)}
                </>
              )}
            </ul>


          </div>
          {/* Active and Queued Calls */}
          <div className="active-queued-calls-container">
            <div className="active-calls-container">
              <FilterHeader heading={`${activeCallCenterCalls.length} Active Calls`} />
              {activeCallCenterCalls.length > 0 ? (
                <ul className="active-calls-list-container">
                  {activeCallCenterCalls.map((call) => {
                    const agentId = call.name?.split('@')[0]; // extract agent UUID
                    const matchedAgent = callCenterAgents.find((a) => a.name === agentId);
                    const extension = matchedAgent?.extension;

                    return (
                      <CallCenterCallItemCard
                        key={call.sessionUUID}
                        phoneNumber={call.callerIDNumber || call.memberCIDNumber}
                        userName={call.callerIDName || call.memberCIDName}
                        departmentName={getQueueNameFromExtension(call.queue || call.queueName)}
                        duration={calculateTimer(new Date(Number(call.joinedEpoch || call.memberJoinedTime) * 1000))}
                        agentExtension={extension || ''}
                        onEndCall={() => dispatch(removeActiveCallsCallCenter(call.sessionUUID))}
                        onClick={() => handleCallClick(call)}
                      />
                    );
                  })}

                </ul>
              ) : (
                <div className="no-calls-message">
                  <Typography variant="text-2">No active calls are present right now.</Typography>
                </div>
              )}
            </div>

            <div className="queued-calls-container">
              <FilterHeader heading={`${queuedCalls.length} Queue`} />
              {queuedCalls.length > 0 ? (
                <ul className="queued-calls-list-container">
                  {queuedCalls.map((call, index) => (
                    <CallCenterCallItemCard
                      key={call.sessionUUID}
                      serialNo={`#${index + 1}`}
                      phoneNumber={call.callerIDNumber || call.memberCIDNumber}
                      userName={call.callerIDName || call.memberCIDName}
                      departmentName={getQueueNameFromExtension(call.queue || call.queueName)}
                      duration={calculateTimer(new Date(Number(call.joinedEpoch) * 1000))}
                      agentExtensions={agentExtensionsMap[call.sessionUUID] || []}
                      onEndCall={() => dispatch(removeCallCenterCallByAgentId(call.sessionUUID))}
                      isQueued={true}
                      onClick={() => handleCallClick(call)}
                    />
                  ))}
                </ul>
              ) : (
                <div className="no-calls-message">
                  <Typography variant="text-2">No queued calls are present right now.</Typography>
                </div>
              )}
            </div>
          </div>

        </div>
      </div>

      <InfoDrawer
        open={modalOpen}
        onCancel={handleCancel}
        callerDetails={[
          { label: 'Caller Name', value: 'John Doe' },
          { label: 'Caller ID', value: '+1 (123) 456-7890' },
          { label: 'Agent Name', value: 'Jane Smith' },
          { label: 'Agent Extension', value: '2001' },
          { label: 'Phone Number', value: '+1 (555) 987-6543' },
          { label: 'Call Duration', value: '00:05:32' },
        ]}
        customDetailsSection={{
          title: 'Department & Agent Details',
          items: [
            { icon: ExtensionIcon, label: 'Department Name', value: 'Sales' },
            { icon: ExtensionIcon, label: 'Number of Agents', value: 5 },
            { icon: ExtensionIcon, label: 'Agents on Call', value: 2 },
            { icon: ExtensionIcon, label: 'Agent Extension', value: '2001' },
            { icon: ExtensionIcon, label: 'Tiers', value: 'Tier 1, Tier 2' },
            { icon: ExtensionIcon, label: 'Status', value: 'Available' },
            { icon: ExtensionIcon, label: 'Caller Number', value: '+1 (999) 555-1234' },
          ],
        }}
        hhaexchangeData={{
          RecordType: 'Patient',
          ID: 'HHA123456',
          Name: 'Michael Johnson',
          Phone: '+1 (888) 123-4567',
          AssignedTo: 'Coordinator A',
        }}
        recentHistory={[]} // or you can provide a mock array of CallHistoryRecord if needed
        historyLoading={false}
        agents={[
          { name: 'Jane Smith', extension: '2001' },
          { name: 'Tom Adams', extension: '2002' },
        ]}
        ivrMenus={[
          { id: 'ivr-1', name: 'Main Menu', extension: '1000' },
        ]}
        queues={[
          { id: 'queue-1', name: 'Support Queue', extension: '3001' },
        ]}
      />
    </DefaultLayout>
  )
}

export default CallCenterDefault;